// extracted by mini-css-extract-plugin
export default {"pageHeader":"jIJ9o0F9wczz92lpNQwC","desktop":"nhS1Yxx8okI1AfqlctUM","mobile":"cYmTogmRu5wrxV6MgtbX","headline":"j00ixQq1LSOy5p99Zage"};